module Eseebase {
    export interface IMenuOpenerScope extends ng.IScope {
    }

    export class MenuOpenerDirective {
        public link: (scope: IMenuOpenerScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => void;
        public scope = {
        };
        public restrict = 'A';
        public require: string;
        public replace: any;
        private static windowEventAttached: boolean;

        constructor() {
            MenuOpenerDirective.prototype.replace = 'false';
            MenuOpenerDirective.prototype.link = (scope: IMenuOpenerScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel: any) => {
                element.click((evt) => {
                    if (evt == null) {
                        return;
                    }
                    evt.stopPropagation();
                    evt.preventDefault();
                    var isExpanded = $(evt.target).closest('.context-menu').hasClass('active');
                    $('.context-menu').removeClass('active');
                    if (!isExpanded) {
                        $(evt.target).closest('.context-menu').addClass('active');
                    }
                });
            };
            if (!MenuOpenerDirective.windowEventAttached) {
                window.addEventListener('click', (evt) => {
                    $('.context-menu').removeClass('active');
                });
                MenuOpenerDirective.windowEventAttached = true;
            }
        }

        public static Factory() {
            var directive = () => {
                return new MenuOpenerDirective();
            };

            directive['$inject'] = [];

            return directive;
        }
    }

    angular
        .module('eseebase')
        .directive('menuOpener', MenuOpenerDirective.Factory());
}